export const RouteGetMerchflows_merchflowId_UhdBuildingBlocksStores =
  "/merchflows/:merchflowId/uhd-building-blocks/stores";

// NOTE: should be sorted by process_order
export type ResponseGetMerchflows_merchflowId_UhdBuildingBlocksStores = {
  store_code: string;
}[];
